<template>
  <div id="contenedor-eliminar-ente-fiscalizador">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Ente Fiscalizador </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el ente fiscalizador "{{enteFiscalizadorEliminar.descripcion}}"?
        </span>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarEnteFiscalizador"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoEntesFiscalizadores from './mixCatalogoEntesFiscalizadores';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoEntesFiscalizadoresEliminar',
  mixins: [mixCatalogoEntesFiscalizadores],
  props: {
    enteFiscalizadorEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">
</style>
